import React, { useState, useEffect } from "react";
import config from '../config';

const BannerImage = () => {
  const [imageExists, setImageExists] = useState(false);
  const imageUrl = `${config.apiUrl}/assets/uploads/banner.png`;

  useEffect(() => {
    // Check if the image exists
    const checkImage = async () => {
      try {
        const response = await fetch(imageUrl, { method: "HEAD" }); // HEAD request to check file existence
        if (response.ok) {
          setImageExists(true);
        } else {
          setImageExists(false);
        }
      } catch (error) {
        setImageExists(false);
      }
    };

    checkImage();
  }, [imageUrl]);

  return (
    <div className="flex w-full justify-center   max-[450px]:mb-1 sm:mb-2 md:mb-2 lg:mb-2  animate-scaleRightIn rounded-2xl">
      {imageExists ? (
        <img 
          src={imageUrl} 
          alt="Banner" 
          className="w-full rounded-2xl object-cover  max-h-60 max-[450px]:max-h-36 sm:max-h-40 md:max-h-60 lg:max-h-64 xl:max-h-64"
        />
      ) : null}
    </div>
  );
  
};

export default BannerImage;
